// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { EmploymentState } from "@/types/employment";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Employment } from "@/models/employment";

const state: EmploymentState = {
  single: new Employment(),
  pagination: new Pagination(),
};

export const employment: Module<EmploymentState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
